module.exports = __webpack_public_path__ + "static/img/pic-project-1.104c940.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/pic-project-1.jpg
// module id = gIyC
// module chunks = 0